import React from 'react';

import classNames from 'classnames';
import _ from 'lodash';

import Menu from './Menu';

class AsyncLive extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedValue: '',
            searchTerm: this.props.initialSearchTerm,
            isFocused: false,
            isOpen: false,
            isSelected: false
        };
    }

    componentDidMount() {
        const { selectedLabel, items, value } = this.props;
        const selectedItem = _.find(items, { value });
        const selectedValue = selectedItem ? selectedItem.label : selectedLabel;

        if (selectedValue) {
            this.setState({
                selectedValue,
                isSelected: true
            });
        }
    }

    componentDidUpdate(prevProps) {
        const initialSearchTermChanged =
            !_.isEqual(
                prevProps.initialSearchTerm,
                this.props.initialSearchTerm
            ) && !_.every(this.props.initialSearchTerm, _.isEmpty);
        if (initialSearchTermChanged) {
            this.setState({ searchTerm: this.props.initialSearchTerm });
        }

        const changedToNoItems =
            !_.isEqual(prevProps.items, this.props.items) &&
            !this.props.items.length;
        if (changedToNoItems && this.props.changeSearchTermOnNoItems) {
            this.setState({
                searchTerm: this.props.changeSearchTermOnNoItems(
                    this.state.searchTerm
                )
            });
        }
    }

    openSearchMenu = () => {
        this.setState({ isOpen: true, isFocused: true });
    };

    closeSearchMenu = () => {
        this.setState({ isFocused: false, isOpen: false });
    };

    resetSelection = () => {
        if (!this.state.isSelected) {
            return;
        }

        this.props.onSelect && this.props.onSelect({ value: '', label: '' });
        this.setState({ isSelected: false });
    };

    setNewSearchTerm = (newSearchTerm, { getNewOptions }) => {
        if (!this.state.isOpen) {
            this.openSearchMenu();
        }
        if (!_.isEqual(newSearchTerm, this.state.searchTerm)) {
            this.setState({ searchTerm: newSearchTerm });
        }

        if (getNewOptions) {
            this.props.getOptions(newSearchTerm);
        }
    };

    selectItem = (item) => {
        const { onSelect } = this.props;
        this.setState({
            selectedValue: item.label,
            isSelected: true,
            isOpen: false,
            isFocused: false
        });
        onSelect && onSelect(item);
    };

    handleMouseDownOnMenu = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    render() {
        const {
            className,
            isLoading,
            renderSearch,
            renderTopMenuElement,
            renderBottomMenuElement,
            ...menuProps
        } = this.props;
        const { isFocused, searchTerm, isSelected, selectedValue, isOpen } =
            this.state;
        const renderProps = {
            isLoading,
            openSearchMenu: this.openSearchMenu,
            closeSearchMenu: this.closeSearchMenu,
            setNewSearchTerm: this.setNewSearchTerm,
            resetSelection: this.resetSelection,
            isSelected,
            selectedValue,
            searchTerm,
            isOpen
        };

        const selectStyle = classNames('iwoca-select', className, {
            'has-focus': isFocused
        });

        return (
            <div className={selectStyle}>
                {renderSearch(renderProps)}

                {this.state.isOpen ? (
                    <Menu
                        className="iwoca-select-container"
                        searchTerm={this.state.searchTerm}
                        selectItem={this.selectItem}
                        handleMouseDownOnMenu={this.handleMouseDownOnMenu}
                        isLoading={isLoading}
                        openSearchMenu={this.openSearchMenu}
                        closeSearchMenu={this.closeSearchMenu}
                        renderTopElement={renderTopMenuElement}
                        renderBottomElement={renderBottomMenuElement}
                        renderProps={renderProps}
                        {...menuProps}
                    />
                ) : null}
            </div>
        );
    }
}

export default AsyncLive;
